<template>
<v-layout wrap row class="wrap">
    <v-flex xs12 sm7 md4 lg3 class="tarjeta-wrap" 
			v-for="(l, idx) in lista" :key="idx"
			@click="girar(idx)"
		>
        <v-layout wrap row justify-center class="tarjeta" :id="'tarjeta'+idx"
					:style="{'background': l.background, 'height': height}"					
				>
            <v-flex text-center class="adelante">
                <div class="tarjeta-contenedor-titulo" v-if="titulo">
                   <h2>{{l.title}}</h2> 
                </div>                
                <div class="tarjeta-contenedor-img" :style="{'height':contImg}">
                    <img :src="require('../assets/'+l.url)" :alt="l.title">
                </div>    
            </v-flex>
            <v-flex class="atras"> 
                <div class="tarjeta-contenedor-titulo-atras" :style="{'background': l.background}"></div>
                <div class="atras-contenido">
                   <p v-html="l.content"></p> 
                </div>                               
            </v-flex>
        </v-layout>
    </v-flex>
</v-layout>    
</template>
<script>
import nextConditions from "../js/mixins/nextConditions";
export default {
 	mixins: [nextConditions],
    props:{		
        lista: {
			type: Array,
		},
		// Altura de la tarjeta
		height:{
			type: String,
			default:'400px'
		},
		// Habilitar titulo en la parte superior de las tarjetas frontales
		titulo:{
			type: Boolean,
			default:false
		},
		// Contenedor de la imagen que determinará la posición vertical
		contImg:{
			type: String,
			default:'100%'
		}
	},
	data(){
		return{
      		vistos:Array(this.lista.length).fill(false),
		}
	},
	methods:{
		girar(idx){
			this.$set(this.vistos, idx, true)
			let tarjeta = document.getElementById('tarjeta'+idx)
			let array_clases = String(tarjeta.classList).split(" ")
			//console.log(array_clases)
			//console.log(array_clases.indexOf('hover-tarjeta'))			
			if (array_clases.indexOf('hover-tarjeta') == -1) {
				tarjeta.classList.add('hover-tarjeta')
			}else{
				tarjeta.classList.remove('hover-tarjeta')
			}
		}
		/*validar(idx){			
			this.$set(this.vistos, idx, true) 
			console.log('visto: '+idx)
		}*/
	}
}
</script>
<style lang="scss" scoped>
    .wrap{
	//width: 1100px;
	margin: 15px auto;
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	justify-content: center;
}
.tarjeta-wrap{
	margin: 10px;
	-webkit-perspective: 800;
	perspective: 800;
}
.tarjeta{
	//width: 300px;
	//height: 400px;
	background: #FFF;
	position: relative;
	-webkit-transform-style: preserve-3d;
	transform-style: preserve-3d;
	-webkit-transition: .7s ease;
	transition: .7s ease;
	-webkit-box-shadow: 0px 10px 15px -5px rgba(0,0,0,0.65);
	box-shadow: 0px 10px 15px -5px rgba(0,0,0,0.65);
}
.adelante, .atras{
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	-webkit-backface-visibility: hidden;
	backface-visibility: hidden;
}
.adelante{
    //width: 100%;
    //display: flex;
    //justify-content: center;
}
.atras{
	-webkit-transform: rotateY(180deg);
	transform: rotateY(180deg);
    background: #FFF;
}
.atras-contenido{
	padding: 10px;
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	justify-content: center;
	-webkit-box-align: center;
	-webkit-align-items: center;
	-ms-flex-align: center;
	align-items: center;
	text-align: center;
	color: #fff;
	//font-family: "open sans";
    background: #FFFFFF;    
}

/*.tarjeta-wrap:hover .tarjeta{
	-webkit-transform: rotateY(180deg);
	transform: rotateY(180deg);
}*/

.hover-tarjeta {
	-webkit-transform: rotateY(180deg);
	transform: rotateY(180deg);
}

.tarjeta-contenedor-img{
    display: flex;
    justify-content: center;
    padding: 7px;
    //height: 100%;
    align-items: center;
}
.tarjeta-contenedor-titulo{
    padding-top: 10px;
    padding-right: 5px;
    padding-left: 5px;
    text-align: center;
    font-size: 1rem;
    height: 20%;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    h2{
        color: #3e3e3e;
    }
}
.tarjeta-contenedor-titulo-atras{
    height: 3%;
    width: 100%;
}
.atras-contenido{
	display: flex;
	align-items: center;
    height: 95%;
}
</style>